export default {
    title: 'Profile',
    profile_information: 'Profile Information',
    profile_info_description: "Update your account's profile information and email address.",
    photo: 'Photo',
    select_new_photo: 'Select A New Photo',
    remove_photo: 'Remove Photo',
    name: 'Name',
    email: 'Email',
    language: 'Language',
    language_en: 'English',
    language_pt: 'Portuguese',
    language_hint: 'Used for the interface, emails, and pricing display where applicable.',
    update_password: 'Update Password',
    password_description: 'Ensure your account is using a long, random password to stay secure.',
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    two_factor: 'Two Factor Authentication',
    two_factor_description:
        'Add additional security to your account using two factor authentication.',
    two_factor_not_enabled: 'You have not enabled two factor authentication.',
    two_factor_enabled: 'You have enabled two factor authentication.',
    two_factor_finish: 'Finish enabling two factor authentication.',
    two_factor_finish_description:
        "To finish enabling two factor authentication, scan the following QR code using your phone's authenticator application or enter the setup key and provide the generated OTP code.",
    two_factor_enabled_description:
        "Two factor authentication is now enabled. Scan the following QR code using your phone's authenticator application or enter the setup key.",
    browser_sessions: 'Browser Sessions',
    browser_sessions_description:
        'Manage and log out your active sessions on other browsers and devices.',
    browser_sessions_info:
        'If necessary, you may log out of all of your other browser sessions across all of your devices. Some of your recent sessions are listed below; however, this list may not be exhaustive. If you feel your account has been compromised, you should also update your password.',
    unknown: 'Unknown',
    this_device: 'This device',
    last_active: 'Last active',
    delete_account: 'Delete Account',
    delete_account_description: 'Permanently delete your account.',
    delete_account_info:
        'Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain.',
    delete_account_confirm:
        'Are you sure you want to delete your account? Once your account is deleted, all of its resources and data will be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.',
    save: 'Save',
    saved: 'Saved.',
    enable: 'Enable',
    disable: 'Disable',
    confirm: 'Confirm',
    setup_key: 'Setup Key',
    code: 'Code',
    recovery_codes_description:
        'Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost.',
    regenerate_recovery_codes: 'Regenerate Recovery Codes',
    show_recovery_codes: 'Show Recovery Codes',
    logout_sessions: 'Log Out Other Browser Sessions',
    logout_sessions_confirm:
        'Please enter your password to confirm you would like to log out of your other browser sessions across all of your devices.',
    password: 'Password',
    done: 'Done',
    cancel: 'Cancel',
};
